import { DocumentData } from "firebase/firestore";
import { GridElement } from "../../../types/gridElement";
import { beforeWrapper } from "../../../utils";

export const PlansInputEstimatedInThisTermTableBlank = ({
  headers,
  title,
  bottomLine,
}: {
  headers: DocumentData[];
  title?: string;
  bottomLine?: boolean;
}) => {
  const grid: GridElement[][] = [];

  // 行の値
  const gridRow = [
    {
      value: title ? title : "",
      readOnly: true,
      className: `${beforeWrapper}  left-0 p-4px bg-white ${
        bottomLine && "before:border-b"
      } `,
      colSpan: 4,
    },
  ];
  headers?.map(() => {
    gridRow.push({
      value: "",
      readOnly: true,
      className: `${beforeWrapper} ${bottomLine && "before:border-b"}`,
      colSpan: 1,
    });
  });
  gridRow.push({
    value: "",
    readOnly: true,
    className: `${beforeWrapper} ${bottomLine && "before:border-b"}`,
    colSpan: 1,
  });
  gridRow.push({
    value: "",
    readOnly: true,
    className: `${beforeWrapper} ${bottomLine && "before:border-b"} h-30px`,
    colSpan: 1,
  });

  grid.push(gridRow);

  return grid;
};
